import {
	type FetchUserAgreementVersionActiveByAgreementTypeParamsAgreementType,
	useIntl,
	type UserAgreementVersion
} from '@capsicum/common';
import { useCallback } from 'react';

import { useMe } from '../../auth';
import { useUserAcceptAgreementQuery, useUserActiveAgreementQuery } from '../data-access';

export const useUserAgreement = (agreementType?: FetchUserAgreementVersionActiveByAgreementTypeParamsAgreementType) => {
	const { me } = useMe();

	const userType: FetchUserAgreementVersionActiveByAgreementTypeParamsAgreementType =
		me.regulation === 'international' ? 'user_agreement' : 'user_agreement_usa';

	const { data, error, isLoading, refetch } = useUserActiveAgreementQuery(
		{
			agreementType: agreementType || userType
		},
		{
			enabled: Boolean(me?.regulation)
		}
	);

	return {
		userActiveAgreement: data,
		userActiveAgreementError: error,
		userActiveAgreementIsLoading: isLoading,
		userActiveAgreementRefetch: refetch
	};
};

const useUserAcceptAgreement = () => {
	const { data, error, isLoading, mutate } = useUserAcceptAgreementQuery();

	return {
		userAcceptAgreementdata: data,
		userAcceptAgreementError: error,
		userAcceptAgreementIsLoading: isLoading,
		userAcceptAgreementMutate: mutate
	};
};

export const useUserAgreementData = (userAgreement?: UserAgreementVersion) => {
	const { getLocalizedField } = useIntl();

	const link = getLocalizedField('link', userAgreement || {});

	return {
		link
	};
};

export const useUserAgreementActions = (
	userActiveAgreement: undefined | UserAgreementVersion,
	closeModal?: (shouldInvokeOnDismiss?: boolean) => void
) => {
	const { userAcceptAgreementError, userAcceptAgreementIsLoading, userAcceptAgreementMutate } =
		useUserAcceptAgreement();

	const acceptUserAgreement = useCallback(async () => {
		if (userActiveAgreement?.id) {
			await userAcceptAgreementMutate(
				{ agreementVersionId: userActiveAgreement.id },
				{
					onSuccess: () => closeModal?.()
				}
			);
		}
	}, [userActiveAgreement, userAcceptAgreementMutate, closeModal]);

	return {
		acceptUserAgreement,
		userAcceptAgreementError,
		userAcceptAgreementIsLoading
	};
};
